import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

const routes = [
    {
        name: 'splash',
        path: '/',
        component: () => import('@/views/Splash')
    },
    {
        name: 'catalog',
        path: '/catalog',
        component: () => import('@/views/Catalog')
    },
    {
        name: 'booking',
        path: '/booking',
        component: () => import('@/views/Booking')
    },
    {
        name: 'confirm',
        path: '/confirm',
        component: () => import('@/views/ConfirmCheckout')
    },
    {
        name: 'checkout',
        path: '/checkout',
        component: () => import('@/views/Checkout')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
